import * as Redux from 'redux';
import { SignupState, SignupActionTypes, SignupResponse } from './signup.types';
import * as SIGNUP_ACTION_TYPES from './signup.constants';
import { ReduxAction, SimpleResponse } from '../app/app.types';
import * as BUSINESS_ACTION_TYPES from '../business/business.constants';
import { REVERT_TO_INITIAL_STATE } from '../app/app.const';
import { initialSignupState } from './signup.constants';

const signupReducer: Redux.Reducer<SignupState> =
  (signupState: SignupState = initialSignupState, 
   action: ReduxAction<SignupActionTypes, SimpleResponse<SignupResponse>>): SignupState => {
  switch (action.type) {
    case REVERT_TO_INITIAL_STATE:
      return initialSignupState;
    case `${SIGNUP_ACTION_TYPES.VALIDATE_EMAIL}_FULFILLED`:
      return {
        ...signupState,
        statusCode: action.payload.statusCode,
        validation: {
          emailValidationStatus: action.payload.statusCode
        }
      };
    case `${SIGNUP_ACTION_TYPES.CREATE_ACCOUNT}_FULFILLED`:
      return action.payload.statusCode === 409 || action.payload.statusCode === 500 ? 
        {
          ...signupState,
          statusCode: action.payload.statusCode,
        } :
        {
          ...signupState,
          account: action.payload.body.entity,
          statusCode: action.payload.statusCode
        };
    case `${SIGNUP_ACTION_TYPES.REGISTER_OR_UPDATE_BUSINESS}_FULFILLED`:
      return action.payload.statusCode === 400 ||
        action.payload.statusCode === 500 ||
        action.payload.statusCode === 409 ?
      { 
        ... signupState,
        statusCode: action.payload.statusCode
      } :
      { 
        ... signupState,
        statusCode: action.payload.statusCode
      };
    case `${SIGNUP_ACTION_TYPES.REGISTER_OR_UPDATE_BUSINESS}_REJECTED`:
      return { 
        ... signupState,
        statusCode: action.payload.statusCode
      };
    case `${BUSINESS_ACTION_TYPES.VALIDATE_PHONE}_FULFILLED`:
      return {
        ... signupState,
        validation: {
          phoneNumberValidationStatus: action.payload.statusCode
        }
      };
    default:
      return signupState;
  }
};

export default signupReducer;



// WEBPACK FOOTER //
// ./src/admin/signup.reducer.tsx